export default __webpack_public_path__ + "static/media/logo-small.36f67d9d.svg";